export class AlertsRequest {
    pageNo: number;
    pageLength: number;
    orderBy: string;
    alertType: number;
    sortColumn: string;
    searchQry: string;
    fromDate: string;
    toDate: string;
}